// @flow

import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { getReportsSearchQuery } from "src/reducers";
import { setReportsSearchQuery } from "src/actions/reports";

import Header from "src/components/SearchHeader.old";

const MenuBar = () => {
  const dispatch = useDispatch();
  const searchQuery = useSelector(({ app }) => getReportsSearchQuery(app));

  const handleSearch = (query: string) => {
    dispatch(setReportsSearchQuery(query));
  };

  return (
    <Header
      addItem={false}
      handleChange={handleSearch}
      text={searchQuery}
      instant
    />
  );
};

export default MenuBar;
